import { gql } from '@apollo/client';

import { theGraphAniftyMarketplaceV1Client } from '@/apis/theGraph/theGraphClients';

export const getPrimarySalesInfoByTokenID = async (
  tokenID: string | number
): Promise<{
  primarySales: {
    id: string;
    saleId: string;
    tokenId: string;
    tokenAmountUnsold: string;
    totalTokenAmount: string;
    price: string;
    creationTimestamp: string;
    seller: string;
    isCancelled: boolean;
    isCompleted: boolean;
  }[];
  primarySaleHistories: {
    id: string;
    saleId: string;
    tokenId: string;
    tokenAmountUnsold: string;
    paymentAmount: string;
    buyTimestamp: string;
    buyer: string;
  }[];
}> => {
  const query = `
    {
      primarySales(where: {tokenId: "${tokenID}"}) {
        id
        saleId
        tokenId
        tokenAmountUnsold
        totalTokenAmount
        price
        creationTimestamp
        seller
        isCancelled
        isCompleted
      }
      primarySaleHistories(where: {tokenId: "${tokenID}"}) {
        id
        saleId
        tokenId
        tokenAmountSold
        paymentAmount
        buyTimestamp
        buyer
      }
    }
  `;

  const response = await theGraphAniftyMarketplaceV1Client.query({
    query: gql(query),
  });

  return response.data;
};
